import { createContext } from "react";

export const MasterLoadsContext = createContext(null); 